// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".apps[data-v-30f9b846] {\n  max-width: 1400px;\n  margin: 0 auto;\n}\n[data-v-30f9b846] .apps-header {\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n}\n[data-v-30f9b846] .table {\n  border-collapse: collapse;\n}\n[data-v-30f9b846] .table tr,[data-v-30f9b846] .table th,[data-v-30f9b846] .table td {\n  border: 1px solid #999;\n  padding: 10px;\n}\n[data-v-30f9b846] .table th {\n  background: #cecece;\n}\n", ""]);
// Exports
module.exports = exports;
